import React, { lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Providers from "providers";
import { useEventListener } from "ahooks";
import isHotkey from "is-hotkey";
import shortkeys from "consts/shortkeys";
import useSWR from "swr";
import { useState } from "@hookstate/core";
import userState from "states/userState";

// import "helpers/xhr"

const Dashboard = lazy(() => import("pages/Dashboard"));
const FreeTrial = lazy(() => import("pages/FreeTrial"));
const Editor = lazy(() => import("pages/Editor"));
const Login = lazy(() => import("pages/Login"));
const SignUp = lazy(() => import("pages/SignUp"));
const Premium = lazy(() => import("pages/Premium"));
const CreateAccount = lazy(() => import("pages/CreateAccount"));
const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const ResetPassword = lazy(() => import("pages/ResetPassword"));
const AuthCallback = lazy(() => import("pages/AuthCallback"));

const Routes: React.FC = () => {
  useEventListener("keydown", (event) => {
    [shortkeys.SHORTKEY_ZOOM_IN, shortkeys.SHORTKEY_ZOOM_OUT].forEach((key) => {
      if (isHotkey(key, event)) {
        event.preventDefault();
      }
    });
  });

  const user = useState(userState);

  useSWR<User>("/users/me", {
    onSuccess: (data) => {
      user.set(data);
    },
  });

  return (
    <Suspense fallback={<></>}>
      <BrowserRouter basename="/design">
        <Switch>
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/free-trial" component={FreeTrial} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={SignUp} />
          <Route exact path="/premium" component={Premium} />
          <Route exact path="/create-account" component={CreateAccount} />
          <Route exact path="/password/forgot" component={ForgotPassword} />
          <Route exact path="/password/reset" component={ResetPassword} />
          <Route exact path="/auth/callback" component={AuthCallback} />
          <Route path="/editor/:uuid" component={Editor} />
          <Route path="/editor/:uuid/preview" component={Editor} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
};

const App: React.FC = () => {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
};

export default App;
